import React from "react";

interface ContactRowProps {
  title: string;
  groups: string[];
  contact: string;
  contacts?: string[];
}

export const ContactRow = ({
  title,
  groups,
  contact,
  contacts = []
}: ContactRowProps) => (
  <div className="px-4 py-3 grid grid-cols-[40%_20%_40%] gap-4 items-center">
    <div className="text-gray-900 font-bold">
      {title}
    </div>
    <div className="text-gray-900">
      {groups.map((group, idx) => (
        <div key={idx}>
          {group}
        </div>
      ))}
    </div>
    <div className="text-gray-400">
      {contact ?? ''}
      {contacts.map((c, idx) => (
        <div key={`c-${idx}`}>
          {c}
        </div>
      ))}
    </div>
  </div>
)